import { render, staticRenderFns } from "./ChooseType.vue?vue&type=template&id=9e178112&scoped=true"
import script from "./ChooseType.vue?vue&type=script&lang=js"
export * from "./ChooseType.vue?vue&type=script&lang=js"
import style0 from "./ChooseType.vue?vue&type=style&index=0&id=9e178112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e178112",
  null
  
)

export default component.exports